export default "__VITE_ASSET__9be44878__"